import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './HowItWorks.css';

const HowItWorks = () => {
  const { t, i18n } = useTranslation();
  const subtitle = t('howItWorks.subtitle');
  const title = t('howItWorks.title');
  const linkText = t('howItWorks.link');
  const steps = t('howItWorks.steps', { returnObjects: true });

  // fallback sample cards in português caso chave sumir:
  const stepsFallback = [
    {
    icon: '/images/ico_01.webp',
      alt: 'Farmácia',
      description: 'Peça o seu kit online ou nas farmácias parceiras.'
    },
    {
    icon: '/images/ico_02.webp',
      alt: 'Coleta',
      description: 'Realize a coleta no conforto de casa, com privacidade total. Sem dor. Sem constrangimento.'
    },
    {
    icon: '/images/ico_03.webp',
      alt: 'Laboratório',
      description: 'Envie ao laboratório. Receba suporte, orientação e resultado com segurança.'
    }
  ];

  const displayedSteps = Array.isArray(steps) && steps.length === 3 ? steps : stepsFallback;

  const langClass = `lang-${(i18n.language || 'pt').slice(0,2)}`;

  return (
    <section className={`how-it-works ${langClass}`}>
      <div className="container">
        <div className="how-it-works-subtitle" data-aos="fade-up">{subtitle}</div>
        <div className="how-it-works-content">
          <div className="how-it-works-text">
            <h2 className="how-it-works-title" data-aos="fade-up" data-aos-delay="100">
              {title}
            </h2>
            <Link to="/kit-lumina" className="how-it-works-link" data-aos="fade-up" data-aos-delay="200">
              {linkText}
            </Link>
          </div>
          <div className="steps">
            {displayedSteps.map((step, i) => (
              <div className="step" data-aos="fade-up" data-aos-delay={300 + (i * 100)} key={i}>
                <div className="step-icon">
                  <div className="icon-box">
                    <img src={step.icon} alt={step.alt} />
                  </div>
                </div>
                <p className="step-description">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;


